// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"71ffffff","189":"55a00f7f","304":"71ffffff","367":"453f951d","585":"bf1397c6","759":"5f9f0c4c","769":"71ffffff","961":"a0e0497b"}[chunkId] + ".css";
};